import { TableBaseCols } from '@ge/feat-reporting/components/widgets/table-widget/table-base-cols';

// All available columns and groups for completed work
export const UptowerRepairDamagesColumns = {
  GROUP_SELECTED: TableBaseCols.GROUP_SELECTED,
  SELECTED: TableBaseCols.SELECTED,

  //GROUP_ASSET_DETAILS: 'Asset Details',
  GROUP_COLUMNS: 'Columns',
  SITE: 'Site',
  ASSET: 'Asset',
  MODEL: 'Model',
  COMPONENT: 'Component',
  LOCATION: 'Location',
  DAMAGE: 'Damage',
  PART: 'Part',
  CATEGORY: 'Category',
  MANUFACTURER: 'Manufacturer',
  RUL_START_DATE: 'RulStartDate',
  P90: 'p90',
};

// Completed work table configuration
export const uptowerRepairDamagesColumnsDefs = {
  [UptowerRepairDamagesColumns.GROUP_COLUMNS]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'external_damages.columns.group_columns',
        a11yDefault: 'Columns',
      },
    ],
    cols: {
      [UptowerRepairDamagesColumns.SITE]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.site',
            a11yDefault: 'Site',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [UptowerRepairDamagesColumns.ASSET]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.asset_name',
            a11yDefault: 'Asset',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [UptowerRepairDamagesColumns.MODEL]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.model',
            a11yDefault: 'Model',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [UptowerRepairDamagesColumns.COMPONENT]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.component',
            a11yDefault: 'Component',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [UptowerRepairDamagesColumns.LOCATION]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.location',
            a11yDefault: 'Location',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [UptowerRepairDamagesColumns.DAMAGE]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.damage',
            a11yDefault: 'Damage',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [UptowerRepairDamagesColumns.PART]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.part',
            a11yDefault: 'Part',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [UptowerRepairDamagesColumns.CATEGORY]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.category',
            a11yDefault: 'Category',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [UptowerRepairDamagesColumns.MANUFACTURER]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.manufacturer',
            a11yDefault: 'Manufacturer',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [UptowerRepairDamagesColumns.RUL_START_DATE]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.rul_start_date',
            a11yDefault: 'RUL Start Date',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [UptowerRepairDamagesColumns.P90]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.p90',
            a11yDefault: 'P90',
          },
        ],
        cell: {
          align: 'left',
        },
      },
    },
  },
};

export const uptowerRepairDamagesColumnsDefaultCols = [
  {
    id: UptowerRepairDamagesColumns.GROUP_COLUMNS,
    ignoreTemplateConfig: true,
    cols: [
      {
        id: UptowerRepairDamagesColumns.SITE,
        visible: true,
      },
      {
        id: UptowerRepairDamagesColumns.ASSET,
        visible: true,
      },
      {
        id: UptowerRepairDamagesColumns.MODEL,
        visible: true,
      },
      {
        id: UptowerRepairDamagesColumns.COMPONENT,
        visible: true,
      },
      {
        id: UptowerRepairDamagesColumns.LOCATION,
        visible: true,
      },
      {
        id: UptowerRepairDamagesColumns.DAMAGE,
        visible: true,
      },
      {
        id: UptowerRepairDamagesColumns.PART,
        visible: true,
      },
      {
        id: UptowerRepairDamagesColumns.CATEGORY,
        visible: true,
      },
      {
        id: UptowerRepairDamagesColumns.MANUFACTURER,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: UptowerRepairDamagesColumns.RUL_START_DATE,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: UptowerRepairDamagesColumns.P90,
        visible: false,
        ignoreTemplateConfig: true,
      },
    ],
  },
];

export const PerformanceStateKeys = {
  CONFIG_STATE: 'configState',
};
